/**
 * Created by Jan Bradac on 7.5.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Modals;

    (function (Modals, $, undefined) {
        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Hides modals displayed on page.
         * @memberOf Lfl.Modals
         */
        Lfl.Modals.Hider;

        (function (Hider, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */



            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * @memberOf Lfl.Modals.Hider
             */
            Hider.hideParentModal = function(elementPath) {
                var $modal = this.getParentModal(elementPath);

                $modal.modal('hide');
            };

            Hider.getParentModal = function(elementPath) {
                var $element = $(elementPath);
                return $($element.closest('.modal'));
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(Modals.Hider = Modals.Hider || {}, jQuery));
    }(Lfl.Modals = Lfl.Modals || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));